import React from 'react';
import * as styles from './styles.scss';

const Input = ({
   id,
   label,
   autoComplete,
   type,
   name,
   error,
   className,
   ...props
}) => (
    <div className={styles.wrapper}>
        {
            label &&
            <label htmlFor={id || name} className={styles.label}>
                {label}
            </label>
        }
        <input
            id={id || name}
            name={name}
            type={type || 'text'}
            autoComplete={autoComplete || 'off'}
            className={styles.input || className}
            {...props}
        />
        {!!error && <span className={styles.error}>{error}</span>}
    </div>
);

export default Input;
